"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timezoneTransformPayload = void 0;
const tslib_1 = require("tslib");
const traverse_1 = tslib_1.__importDefault(require("traverse"));
const global_object_1 = tslib_1.__importDefault(require("../../global-object"));
const format_date_1 = require("./format-date");
function timezoneTransformPayload(data, timezone) {
    if (typeof data !== 'object' && !Array.isArray(data))
        return data;
    return (0, traverse_1.default)(data).map(function (value) {
        var _a;
        if (value instanceof Date) {
            this.update((0, format_date_1.formatDateString)(value, ((_a = global_object_1.default === null || global_object_1.default === void 0 ? void 0 : global_object_1.default.App) === null || _a === void 0 ? void 0 : _a.timezoneId) || timezone));
        }
    });
}
exports.timezoneTransformPayload = timezoneTransformPayload;
//# sourceMappingURL=timezone-transform-payload.js.map